import Wizard from "components/wizard/Wizard";
import { ACTIVATION_TYPES } from "utils/constants";

const initialData = {
    subtype: "standard",
    name: null,
    email: null,
    phone1: null,
    phone2: null,
    mobile: null,
    commercial_reference: null,
    technical_reference: null,
    address: null,
    city: null,
    province: null,
    zip_code: null,
    country: "ITALY",
    description: null,
    licenses: [],
    total: 0,
    maintenance: 0,
    reseller_code: null,
    reseller_note: null,
};

const purchaseSteps = [2, 3];

const stepsConfig = [
    {
        number: 1,
        summaryTitle: "Dati anagrafici",
    },
    {
        number: 2,
        summaryTitle: "Tipologia licenza",
    },
    {
        number: 3,
        summaryTitle: "Licenze",
    },
];

const licenseTypesConfig = [
    {
        key: "standard",
    },
    {
        key: "bridge",
    },
    {
        key: "channels",
    },
];

const Cloud = () => {
    return (
        <Wizard
            activationType={ACTIVATION_TYPES.CLOUD}
            initialData={initialData}
            stepsConfig={stepsConfig}
            licenseTypesConfig={licenseTypesConfig}
            purchaseSteps={purchaseSteps}
        />
    );
};

export default Cloud;
